module.exports = __webpack_public_path__ + "static/media/brainz-magazine-logo.732daf86.png";